/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-resource-button.vue?vue&type=template&id=fff503ca&scoped=true&"
import script from "./edit-resource-button.vue?vue&type=script&lang=js&"
export * from "./edit-resource-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff503ca",
  null
  
)

export default component.exports